export const useDefaultData = ({helpers}) => {

    const {getCurrentDate} = helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormVehicle = {
        idvehicle: 0,
        tipo: '',
        marca: '',
        modelo: '',
        linea: '',
        matricula: '',
        color: '',
        motorCC: '',
        motorNo: '',
        chasis: '',
        origen: '',
        disponibilidad: '',
        costo: '',
        costo_clean: '',
        costo_total: 0,
        clean_costo_total: 0,
        images: [],
        files: [],
        fileRejections: [],
        acceptedFiles: [],       
    }

    const defaultFormExpenses = {
        idexpense: 0,
        title : '',
        description : '',
        supplier : '',
        advance : '',	
        expense : '',
        clean_advance: 0,
        clean_expense: 0,
        check_print: false
    }

    const defaultFormAdvance = {
        idadvance: 0,
        description : '',
        advance : '',
        clean_advance: 0,
    }

    const defaultFormStatus = {
        idestado: 0,
        fecha: getCurrentDate(),
        disponibilidad: '',
        ubicacion: '',
        description : '',
    }

    const optionsOrigen = [
        { value: 'IMPORTADO', label: 'IMPORTADO' },
        { value: 'AGENCIA', label: 'AGENCIA' },
        { value: 'COMPRA LOCAL', label: 'COMPRA LOCAL' },
        { value: 'A CONSIGNACION', label: 'A CONSIGNACION' },
    ];

    const optionsStatus = [
        { value: 'DISPONIBLE', label: 'DISPONIBLE' },
        { value: 'NO DISPONIBLE', label: 'NO DISPONIBLE' },
        { value: 'EN TALLER', label: 'EN TALLER' },
        { value: 'EN CONTRATO', label: 'EN CONTRATO' },
        { value: 'SOLICITADO', label: 'SOLICITADO' },
    ];

    const optionsLocation = [
        { value: 'EN SUBASTA', label: 'EN SUBASTA' },
        { value: 'EN YARDA', label: 'EN YARDA' },
        { value: 'EN TRANSITO', label: 'EN TRANSITO' },
        { value: 'ADUANA / FRONTERA', label: 'ADUANA / FRONTERA' },
        { value: 'EN GUATEMALA', label: 'EN GUATEMALA' },
        { value: 'PREDIO', label: 'PREDIO' },
    ];


    return Object.freeze({
        defaultFormVehicle,
        defaultFormExpenses,
        defaultFormAdvance,
        defaultDataModal,
        defaultFormStatus,
        optionsOrigen,
        optionsStatus,
        optionsLocation,
    })
}